import { DOCUMENT, NgIf } from '@angular/common';
import { Component, Inject, OnInit, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { OAuthConstants } from '../../../oauth/constant/oAuth.constants';
import { AuthRevokeRoutes } from '../../../oauth/models/routes/AuthRevokeRoutes.constant';
import { AuthRoutes } from '../../../oauth/models/routes/AuthRoutes.constant';
import { LoginPageApiService } from '../../../core/services/login-page-api.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'saml-error',
    templateUrl: 'saml-error-page.component.html',
    styleUrls: ['saml-error-page.component.scss'],
    imports: [NgIf]
})
export class SamlErrorPageComponent implements OnInit {

  public errorMsg: string;
  public disableGreytHrLogo = false;
  private destroyRef = inject(DestroyRef);
  constructor(private route: ActivatedRoute,
              private _router: Router,
              @Inject(DOCUMENT) private document: any,
              private _loginPageApiService: LoginPageApiService,) { }

  public ngOnInit() {
    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params: Params) => {
        this.errorMsg = params.msg;
      });
    this._loginPageApiService.getLoginPage()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.disableGreytHrLogo = res['disableGreytHrLogo'] || false;
      });
  }

  public returnToLogin() {
    this.document.location.href = `${this.document.location.origin}${AuthRoutes.LOGIN}`;
  }

  public redirectToApp() {
      this.document.location.href = `${this.document.location.origin}` ;
  }
}
